<template>
  <div class="relative w-full lg:h-[70vh] h-[30vh]">
    <!-- Background Image -->
    <div class="absolute inset-0 overflow-hidden">
      <img
        src="../assets/images/hero-banner.png"
        alt="Background"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>

    <!-- Content Wrapper -->
    <div
      class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
    >
      <h2
        class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
      >
        Contact Us
      </h2>
    </div>
  </div>

  <!-- Content Wrapper -->
  <section class="bg-gradient-to-br from-gray-50 to-blue-50 py-16 h-screen">
    <div class="md:px-4 max-w-7xl mx-auto">
      <!-- Section Header -->
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Get In Touch
        </h2>
        <p class="text-gray-600 max-w-2xl mx-auto">
          Ready to connect? Reach out to us through any of these channels and
          let's start a conversation.
        </p>
      </div>

      <!-- Contact Cards Grid -->
      <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8"
      >
        <!-- Phone Card -->
        <div
          class="cursor-pointer group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
        >
          <!-- Background Pattern -->
          <div
            class="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          ></div>

          <!-- Icon Container -->
          <div class="relative z-10 flex flex-col items-center">
            <div
              class="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex justify-center items-center mb-6 transform group-hover:rotate-6 group-hover:scale-110 transition-all duration-300 shadow-lg"
            >
              <i
                class="fa-solid fa-phone text-2xl text-white group-hover:animate-pulse"
              ></i>
            </div>

            <!-- Content -->
            <h3 class="text-lg font-semibold text-gray-800 mb-3">Call Us</h3>
            <a
              href="tel:+2347068777793"
              class="text-blue-600 hover:text-blue-700 font-medium text-center transition-colors duration-200 hover:underline decoration-2 underline-offset-4"
            >
              +234 7098908789
            </a>
            <p class="text-gray-500 text-sm mt-2 text-center">
              Available during business hours
            </p>
          </div>
        </div>

        <!-- Email Card -->
        <div
          class="cursor-pointer group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
        >
          <!-- Background Pattern -->
          <div
            class="absolute inset-0 bg-gradient-to-br from-green-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          ></div>

          <!-- Icon Container -->
          <div class="relative z-10 flex flex-col items-center">
            <div
              class="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex justify-center items-center mb-6 transform group-hover:rotate-6 group-hover:scale-110 transition-all duration-300 shadow-lg"
            >
              <i
                class="fa-solid fa-envelope text-2xl text-white group-hover:animate-pulse"
              ></i>
            </div>

            <!-- Content -->
            <h3 class="text-lg font-semibold text-gray-800 mb-3">Email Us</h3>
            <a
              href="mailto:info@mshelgroup.com"
              class="text-green-600 hover:text-green-700 font-medium text-center transition-colors duration-200 hover:underline decoration-2 underline-offset-4 break-all"
            >
              info@mshelgroup.com
            </a>
            <p class="text-gray-500 text-sm mt-2 text-center">
              We'll respond within 24 hours
            </p>
          </div>
        </div>

        <!-- Location Card -->
        <div
          class="cursor-pointer group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
        >
          <!-- Background Pattern -->
          <div
            class="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          ></div>

          <!-- Icon Container -->
          <div class="relative z-10 flex flex-col items-center">
            <div
              class="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl flex justify-center items-center mb-6 transform group-hover:rotate-6 group-hover:scale-110 transition-all duration-300 shadow-lg"
            >
              <i
                class="fa-solid fa-map-marker-alt text-2xl text-white group-hover:animate-pulse"
              ></i>
            </div>

            <!-- Content -->
            <h3 class="text-lg font-semibold text-gray-800 mb-3">Visit Us</h3>
            <p class="text-purple-600 font-medium text-center leading-relaxed">
              The Mshel Hub, No. 2 Julius Adelusi Street, Guzape, Abuja.
            </p>
            <p class="text-gray-500 text-sm mt-2 text-center">
              Find us on the map
            </p>
          </div>
        </div>

        <!-- Hours Card -->
        <div
          class="cursor-pointer group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
        >
          <!-- Background Pattern -->
          <div
            class="absolute inset-0 bg-gradient-to-br from-orange-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          ></div>

          <!-- Icon Container -->
          <div class="relative z-10 flex flex-col items-center">
            <div
              class="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex justify-center items-center mb-6 transform group-hover:rotate-6 group-hover:scale-110 transition-all duration-300 shadow-lg"
            >
              <i
                class="fa-solid fa-clock text-2xl text-white group-hover:animate-pulse"
              ></i>
            </div>

            <!-- Content -->
            <h3 class="text-lg font-semibold text-gray-800 mb-3">
              Business Hours
            </h3>
            <p class="text-orange-600 font-medium text-center">
              8:00 AM - 5:00 PM
            </p>
            <p class="text-gray-600 font-medium text-center mt-1">
              Monday - Friday
            </p>
            <p class="text-gray-500 text-sm mt-2 text-center">
              Closed on weekends
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Google map and image section -->
  <div class="md:px-4 max-w-screen-3xl mx-auto py-10">
    <h2 class="text-2xl font-semibold text-center mb-6">Visit Us</h2>
    <div class="grid md:grid-cols-1 gap-6 px-10">
      <!-- Google Map Embed -->
      <iframe
        class="w-full h-96 rounded-lg shadow-lg"
        frameborder="0"
        style="border: 0"
        :src="mapSrc"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      address: "The Mshel Hub, No. 2 Julius Adelusi Street, Guzape, Abuja",
    };
  },
  computed: {
    mapSrc() {
      const query = encodeURIComponent(this.address);
      return `https://www.google.com/maps?q=${query}&output=embed`;
    },
    staticMapImg() {
      const query = encodeURIComponent(this.address);
      return `https://maps.googleapis.com/maps/api/staticmap?center=${query}&zoom=15&size=600x400&markers=color:red%7C${query}`;
    },
  },
};
</script>

<style scoped></style>
